/** 選択パスから、子孫に含まれる重複を除いた最上位パスを返す。 */
export function getTopLevelEnvironmentPaths(paths: readonly string[]): string[] {
	const normalized = [
		...new Set(paths.map((path) => path.replaceAll("\\", "/").trim()).filter(Boolean)),
	].sort((a, b) => a.length - b.length || a.localeCompare(b));
	return normalized.filter(
		(path, index) => !normalized.slice(0, index).some((parent) => path.startsWith(`${parent}/`)),
	);
}

/**
 * 選択パスから、指定ディレクトリへの移動で実際に動くパスだけを返す。
 * 最上位パスへ折りたたんだうえで、移動先が既に自分の親ディレクトリと同じもの (no-op) を除く。
 * ドラッグ&ドロップの可否判定 (`canDropEnvironmentEntries`) と実際の移動処理 (`moveEnvironmentEntries`)
 * の両方がこの関数を経由することで、両者の判定が食い違い「ドロップは受理されたのに何も移動されない」
 * ことがないようにする。
 */
export function getMovableEnvironmentPaths(
	paths: readonly string[],
	destinationDirPath: string,
): string[] {
	return getTopLevelEnvironmentPaths(paths).filter((path) => {
		const slash = path.lastIndexOf("/");
		return (slash === -1 ? "" : path.slice(0, slash)) !== destinationDirPath;
	});
}
